import PunchesPage from "./PunchesPage";

export default {
    list: PunchesPage,
    create: PunchesPage,
};